import { useEffect, useState } from 'react'

type CustomProgressBarProps = {
    swapInProgress:boolean;
    progress: number;
    setProgress: React.Dispatch<React.SetStateAction<number>>;
    customLoadingMessages? : string[];
}

const defaultLoadingMessages = [
  "Uploading images...",
  "Detecting faces...",
  "Analyzing facial landmarks...",
  "Matching expressions...",
  "Aligning face geometry...",
  "Swapping facial features...",
  "Enhancing image quality...",
  "Rendering final result..."
];


const CustomProgressBar = ({swapInProgress,progress, setProgress, customLoadingMessages}:CustomProgressBarProps) => {
    if(!customLoadingMessages || customLoadingMessages.length == 0){
        customLoadingMessages = defaultLoadingMessages;
    }
    const [messageFreq, setmessageFreq] = useState(0);
    
    useEffect(()=>{
        setmessageFreq(Math.floor(100 / customLoadingMessages.length));
    },[customLoadingMessages])

    useEffect(() => {
  if (!swapInProgress) {
    setProgress(0);
    return;
  }

  let isCancelled = false;

  const simulateProgress = async () => {
    const targetTime = 90000;
    const startTime = Date.now();

    while (!isCancelled && progress < 95) {
      const elapsed = Date.now() - startTime;
      const expectedProgress = (elapsed / targetTime) * 95;

      await new Promise((res) => setTimeout(res, 500));
      
      setProgress((prev) => {
        if (prev >= 95) return prev;
        const next = Math.min(expectedProgress, 95);
        
        return Math.max(prev, next);
      });
    }
  };

  simulateProgress();

  return () => {
    isCancelled = true;
  };
}, [swapInProgress]);

    
  return (
    <div className="text-center w-75 mx-auto mt-4">
        <p className="mb-2 fw-medium" style={{
          fontSize:"20px",
          color: "white"
        }}>
        {customLoadingMessages[Math.floor(progress / messageFreq)]}
        </p>
        <div className="progress" style={{ height: "20px" ,background:"white" }}>
        <div
            className="progress-bar progress-bar-animated"
            role="progressbar"
            style={{ 
              width: `${progress}%`,
              backgroundImage: `
                linear-gradient(
                  45deg,
                  rgba(255,255,255,.25) 25%,
                  transparent 25%,
                  transparent 50%,
                  rgba(255,255,255,.25) 50%,
                  rgba(255,255,255,.25) 75%,
                  transparent 75%,
                  transparent
                ),
                linear-gradient(135deg, #667eea 0%, #764ba2 100%)
              `,
               backgroundSize: "1rem 1rem, 100% 100%",
                transition: 'width 0.3s ease',
            }}
            aria-valuenow={Math.round(progress)}
            aria-valuemin={0}
            aria-valuemax={100}
        >
            {Math.round(progress)}%
        </div>
        </div>
    </div>
  )
}

export default CustomProgressBar